import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Label } from './label.jsx';
import { getExtension } from '../../utils/utils.js'


const Content = styled.div`
    display: flex;
    padding: ${props => props.padding ? props.padding : 'none'};
    float: ${props => props.float ? props.float : 'left'};
    margin: ${props => props.margin ? props.margin : '0 0'};
`;

//TODO: Check height fails when text has two lines
const IconContent = styled.div`
    width: ${props => props.ic_size ? props.ic_size : '25px'};
    height: ${props => props.ic_size ? props.ic_size : '25px'};
    margin-left: ${props => props.separation ? props.separation : '15px'};
    margin-right: ${props => props.separation ? props.separation : '15px'};
    ${props => props.valign ? 'none' : 'position: relative;'}
    ${props => props.valign ? 'none' : 'top: ' + props.ic_top};
`;

const SVGStyled = styled(SVG)`
    width: ${props => props.ic_size ? props.ic_size : '25px'};
    height: ${props => props.ic_size ? props.ic_size : '25px'};
    display: block;
    ${props => props.ic_color ? 'fill: ' + props.ic_color : 'none'};
`;

const Icon = styled.img`
    height: 100%;
    width: 100%;
    display: block;
`;


const TextIcon = ({
    ic_path,
    ic_color,
    ic_size,
    ic_align,
    ic_top = '8px',
    ic_id,
    text_color,
    text_size,
    font_family,
    margin,
    separation,
    padding,
    float,
    valign = true,
    children
}) => {

    const icAlign = ic_align ? ic_align : 'left';
    const labelMargin = '0 ' + separation + ' 0 ' + separation;

    var icContent
    if (ic_path) {
        const icExtension = getExtension(ic_path)
        icContent = (icExtension === 'svg' && ic_color) ? 
        <IconContent
            ic_size={ic_size}
            ic_top={ic_top}
            separation={separation}
            valign={valign} >
            <SVGStyled 
                ic_size={ic_size}
                src={ic_path}
                ic_color={ic_color}
                />
        </IconContent>
        :
        <IconContent
            ic_size={ic_size}
            ic_top={ic_top}
            separation={separation}
            valign={valign} >
            <Icon 
                src={ic_path}
                ic_color={ic_color}
                />
        </IconContent>;
    } else {
        icContent = null
    }
    
    var label =
    <Label
        text_color={text_color}
        text_size={text_size}
        font_family={font_family}
        margin={labelMargin} >
        {children}
    </Label>;
        

    if (icAlign === 'right') {
        return (
            <Content
                className={valign ? 'valign-wrapper' : 'none'}
                float={float}
                margin={margin}
                padding={padding}>
                { label }
                { icContent }
            </Content>
        )
    } 
    else {
        return (
            <Content
                id={ic_id}
                className={valign ? 'valign-wrapper' : 'none'}
                float={float}
                margin={margin}
                padding={padding}>
                { icContent }
                { label }
            </Content>
        )
    }
}

export default TextIcon;